export enum AuthDenialCode {
    TenantSelectionFailed = 'TENANT_SELECTION_FAILED',
    Unknown = 'UNKNOWN',
}

export enum AuthRecoveryCode {
    ReauthenticationRequired = 'REAUTHENTICATION_REQUIRED',
}